<template>
	<article class="product-list--page">
		<form @submit.prevent="searching">
			<product-list-filter
				ref="filter"
				@change="change"
				:storeList="selectboxStoreList"
				:idProduct="idProduct"
				:searchType="searchType"
				:productTitle="productTitle"
				:minPrice="minPrice"
				:maxPrice="maxPrice"
				:productText="productText"
				:startFactorsInsertDate="startFactorsInsertDate"
				:endFactorsInsertDate="endFactorsInsertDate"
				:startModifiedFactorsDate="startModifiedFactorsDate"
				:endModifiedFactorsDate="endModifiedFactorsDate"
				:startDate="startDate"
				:endDate="endDate"
				:isDiscontinue="isDiscontinue"
				:keyword="keyword"
				:colorType="colorType"
				:idBrandType="idBrandType"
				:startReleaseDate="startReleaseDate"
				:endReleaseDate="endReleaseDate"
				:isDisplay="isDisplay"
				:startModifiedDate="startModifiedDate"
				:endModifiedDate="endModifiedDate"
				:min-rating-avg="minRatingAvg"
				:max-rating-avg="maxRatingAvg"
				:min-review-count="minReviewCount"
				:max-review-count="maxReviewCount"
			/>
			<div class="btn-wrap-main">
				<button
					type="button"
					class="btn-main blue bordered"
					v-text="'초기화'"
					@click="init"
				/>
				<button type="submit" class="btn-main blue" v-text="'검색'" />
			</div>
		</form>
		<product-list-table
			@paging="paging"
			@change="change"
			@changeListDisplay="changeListDisplay"
			:products="products"
			:totalItem="totalItem"
			:isDisplayCnt="isDisplayCnt"
			:unIsDisplayCnt="unIsDisplayCnt"
			:offset="offset"
			:limit="limit"
		/>
	</article>
</template>
<script>
	import { mapGetters } from 'vuex';
	import _ from 'lodash';
	import moment from 'moment';
	import util from '@/util';
	import ProductListFilter from '@/components/product/ProductListFilter.vue';
	import ProductListTable from '@/components/product/ProductListTable.vue';

	export default {
		name: 'ProductList',
		components: { ProductListFilter, ProductListTable },
		data() {
			return {
				filterKeys: [
					'firstCategory',
					'secondCategory',
					'thirdCategory',
					'minPrice',
					'maxPrice',
					'productText',
					'keyword',
					'startFactorsInsertDate',
					'startModifiedFactorsDate',
					'startDate',
					'startModifiedDate',
					'endFactorsInsertDate',
					'endModifiedFactorsDate',
					'endDate',
					'endModifiedDate',
					'isDiscontinue',
					'idBrand',
					'startReleaseDate',
					'endReleaseDate',
					'isDisplay',
					'minRatingAvg',
					'maxRatingAvg',
					'minReviewCount',
					'maxReviewCount',
					'colorType',
				],
				idProduct: '',
				searchType: 0,
				productTitle: '',
				minPrice: '',
				maxPrice: '',
				productText: '',
				startFactorsInsertDate: '',
				endFactorsInsertDate: '',
				startModifiedFactorsDate: '',
				endModifiedFactorsDate: '',
				isDiscontinue: null,
				idBrand: null,
				keyword: '',
				startDate: '',
				endDate: '',
				startModifiedDate: '',
				endModifiedDate: '',
				startReleaseDate: '',
				endReleaseDate: '',
				idBrandType: null,
				totalItem: 0,
				isDisplayCnt: 0,
				unIsDisplayCnt: 0,
				offset: 0,
				limit: 50,
				products: [],
				order: 11,
				firstCategory: null,
				secondCategory: null,
				thirdCategory: null,
				isDisplay: null,
				minReviewCount: '',
				maxReviewCount: '',
				minRatingAvg: '',
				maxRatingAvg: '',
				colorType: '',
			};
		},
		computed: {
			...mapGetters('productList', ['selectboxStoreList']),
		},
		watch: {
			limit(limit) {
				this.changeImmediately(limit, 'limit');
			},
			order(order) {
				this.changeImmediately(order, 'order');
			},
			searchType(searchType) {
				this.$nextTick(() => {
					if (searchType !== 1) this.init();
				});
			},
		},
		created() {
			const searchType = this.$route.query.searchType;
			if (this.isExist(searchType)) this.searchType = Number(searchType);
		},
		async mounted() {
			const query = this.$route.query;
			await this.$store.dispatch('productList/getStoreList');
			this.setFilter(query);
			await this.getList(query);
		},
		methods: {
			isExist(value) {
				return !!value || value === 0;
			},
			setFilter(query) {
				const isExist = this.isExist;
				if (_.isEmpty(query)) return;
				query = _.cloneDeep(query);
				const searchType = [
					'offset',
					'limit',
					'order',
					'searchType',
				].reduce((acc, key) => {
					const val = query[key];
					if (isExist(val)) {
						this[key] = Number(val);
						if (key === 'searchType') acc = Number(val);
					}
					return acc;
				}, null);
				if (searchType === 1) {
					if (isExist(query.idProduct))
						this.idProduct = String(query.idProduct);
					return;
				} else if (searchType === 0 && !!query.productTitle) {
					this.productTitle = query.productTitle;
				} else if (searchType === 2 && isExist(query.idBrandType)) {
					this.idBrandType = Number(query.idBrandType);
				}
				this.filterKeys.forEach(key => {
					const val = query[key];
					switch (key) {
						case 'firstCategory':
						case 'secondCategory':
						case 'thirdCategory':
						case 'minPrice':
						case 'maxPrice':
						case 'minRatingAvg':
						case 'maxRatingAvg':
							if (isExist(val)) {
								this[key] =
									typeof val === 'number'
										? val.toString()
										: val;
							}
							break;
						case 'minReviewCount':
						case 'maxReviewCount':
							if (isExist(val)) {
								this[key] = util.currency(val.toString());
							}
							break;
						case 'productText':
						case 'colorType':
						case 'keyword':
							if (!!val) this[key] = val;
							break;
						case 'startFactorsInsertDate':
						case 'startModifiedFactorsDate':
						case 'startDate':
						case 'startModifiedDate':
						case 'endFactorsInsertDate':
						case 'endModifiedFactorsDate':
						case 'endDate':
						case 'endModifiedDate':
						case 'startReleaseDate':
						case 'endReleaseDate':
							if (val) {
								this[key] = val;
							}
							break;
						case 'isDiscontinue':
						case 'isDisplay':
							if (!!val || val === false)
								this[key] = val === 'true' || val === true;
							break;
						case 'idBrand':
							if (isExist(val)) {
								const idBrandModule =
									this.$refs.filter.$refs.idBrand;
								this[key] = Number(val);
								idBrandModule.setBrandOnlyId(Number(val));
							}
							break;
					}
				});
				this.$refs.filter.setCategory(query);
			},
			getParams(query) {
				const isExist = this.isExist;
				query = _.cloneDeep(query);
				const params = {};
				['offset', 'limit', 'order'].forEach(key => {
					const val = query[key];
					params[key] = isExist(val) ? Number(val) : this[key];
				});
				if (_.isEmpty(query)) return params;
				const searchType = isExist(query.searchType)
					? Number(query.searchType)
					: null;
				if (searchType === 1) {
					if (isExist(query.idProduct))
						params.idProduct = Number(query.idProduct);
					return params;
				} else if (searchType === 0 && !!query.productTitle) {
					params.productTitle = query.productTitle;
				} else if (searchType === 2 && isExist(query.idBrandType)) {
					params.idBrandType = Number(query.idBrandType);
				}
				this.filterKeys.forEach(key => {
					const val = query[key];
					switch (key) {
						case 'firstCategory':
						case 'secondCategory':
						case 'thirdCategory':
						case 'minRatingAvg':
						case 'maxRatingAvg':
						case 'minPrice':
						case 'maxPrice':
						case 'minReviewCount':
						case 'maxReviewCount':
						case 'idBrand':
							if (isExist(val)) params[key] = Number(val);
							break;
						case 'productText':
						case 'colorType':
						case 'keyword':
							if (!!val) params[key] = val;
							break;
						case 'startReleaseDate':
						case 'endReleaseDate':
							if (val) {
								params[key] = val.replace('-', '');
							}
							break;
						case 'startFactorsInsertDate':
						case 'startModifiedFactorsDate':
						case 'startDate':
						case 'startModifiedDate':
						case 'endFactorsInsertDate':
						case 'endModifiedFactorsDate':
						case 'endDate':
						case 'endModifiedDate':
							if (val) {
								if (key.indexOf('start') === 0) {
									params[key] = moment(
										val,
										'YYYY-MM-DD'
									).format('YYYYMMDDHHmmss');
								} else {
									params[key] = moment(val, 'YYYY-MM-DD')
										.endOf('date')
										.format('YYYYMMDDHHmmss');
								}
							}
							break;
						case 'isDiscontinue':
						case 'isDisplay':
							if (!!val || val === false)
								params[key] = val === 'true' || val === true;
							break;
					}
				});
				return params;
			},
			async getList(query) {
				try {
					const params = this.getParams(query);
					const url = '/api/products/list';
					const { data } = await this.$axiosAdmin2.get(url, {
						params,
					});
					this.$store.commit('productList/changeState', [
						{
							key: 'totalItem',
							value: data.total,
						},
					]);
					this.totalItem = data.total;
					this.isDisplayCnt = data.isDisplayCnt;
					this.unIsDisplayCnt = data.unIsDisplayCnt;
					this.products = data.products;
					this.$store.commit('productList/changeState', [
						{
							key: 'lastParams',
							value: params,
						},
					]);
				} catch (err) {
					console.error(err);
					alert(
						'제품 리스트를 불러오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			changeListDisplay(idProduct) {
				if (!this.products || this.products.length < 1) return;
				this.products = this.products.map(item => {
					if (item.idProduct === idProduct) {
						item.isDisplay = !item.isDisplay;
					}
					return item;
				});
			},
			change(changeList) {
				const searchType = changeList.find(
					item => item.key === 'searchType'
				);

				if (searchType && searchType.value === 1) {
					this.init();
				}

				changeList.forEach(({ key, value }) => {
					this[key] = value;
				});
			},
			validation() {
				if (
					this.minPrice &&
					this.maxPrice &&
					Number(this.minPrice) > Number(this.maxPrice)
				) {
					alert('가격이 잘못 입력되었습니다');
					return false;
				}
				if (
					this.startFactorsInsertDate &&
					this.endFactorsInsertDate &&
					this.startFactorsInsertDate > this.endFactorsInsertDate
				) {
					alert('성분 등록일이 잘못 입력되었습니다');
					return false;
				}
				if (
					this.startModifiedFactorsDate &&
					this.endModifiedFactorsDate &&
					this.startModifiedFactorsDate > this.endModifiedFactorsDate
				) {
					alert('성분 수정일이 잘못 입력되었습니다');
					return false;
				}
				if (
					this.startDate &&
					this.endDate &&
					this.startDate > this.endDate
				) {
					alert('등록일이 잘못 입력되었습니다');
					return false;
				}
				if (
					this.startModifiedDate &&
					this.endModifiedDate &&
					this.startModifiedDate > this.endModifiedDate
				) {
					alert('수정일이 잘못 입력되었습니다');
					return false;
				}
				if (
					this.startReleaseDate &&
					this.endReleaseDate &&
					this.startReleaseDate > this.endReleaseDate
				) {
					alert('출시일이 잘못 입력되었습니다');
					return false;
				}
				if (this.searchType === 2 && !this.idBrandType) {
					alert('검색할 스토어를 선택하세요.');
					return false;
				}
				if (
					this.minRatingAvg &&
					this.maxRatingAvg &&
					this.minRatingAvg > this.maxRatingAvg
				) {
					alert('최소 평점이 최대 평점보다 큽니다');
					return false;
				}

				if (
					this.minReviewCount &&
					this.maxReviewCount &&
					Number(this.minReviewCount.split(',').join('')) >
						Number(this.maxReviewCount.split(',').join(''))
				) {
					alert('최소 리뷰수가 최대 리뷰수보다 큽니다');
					return false;
				}
				return true;
			},
			setQuery() {
				const query = {
					searchType: this.searchType,
					offset: this.offset,
					limit: this.limit,
					order: this.order,
				};

				if (this.searchType === 1 && this.idProduct) {
					query.idProduct = Number(this.idProduct);
				} else {
					if (this.searchType === 0 && this.productTitle) {
						query.productTitle = this.productTitle;
					} else if (
						this.searchType === 2 &&
						typeof this.idBrandType === 'number'
					) {
						query.idBrandType = this.idBrandType;
					}
					this.filterKeys.forEach(key => {
						const val = this[key];
						switch (key) {
							case 'firstCategory':
							case 'secondCategory':
							case 'thirdCategory':
							case 'idBrand':
								if (typeof val === 'number') query[key] = val;
								break;
							case 'minPrice':
							case 'maxPrice':
							case 'productText':
							case 'colorType':
							case 'keyword':
								if (!!val) query[key] = val;
								break;
							case 'minRatingAvg':
							case 'maxRatingAvg':
								if (val) {
									query[key] = /^\d+(\.)$/.test(val)
										? Number(val)
										: val;
								}
								break;
							case 'minReviewCount':
							case 'maxReviewCount':
								if (val) {
									query[key] = val
										.toString()
										.split(',')
										.join('');
								}
								break;
							case 'startFactorsInsertDate':
							case 'startModifiedFactorsDate':
							case 'startDate':
							case 'startModifiedDate':
							case 'endFactorsInsertDate':
							case 'endModifiedFactorsDate':
							case 'endDate':
							case 'endModifiedDate':
							case 'startReleaseDate':
							case 'endReleaseDate':
								if (!!val) query[key] = val;
								break;
							case 'isDiscontinue':
							case 'isDisplay':
								if (typeof val === 'boolean') query[key] = val;
								break;
						}
					});
				}
				this.$router.replace({ query });
				return query;
			},
			async searching() {
				if (this.validation()) {
					this.offset = 0;
					const query = this.setQuery();
					await this.getList(query);
				}
			},
			async changeImmediately(nv, targetKey) {
				this[targetKey] = nv;
				if (nv === Number(this.$route.query[targetKey])) return;
				const query = _.cloneDeep(this.$route.query);
				query[targetKey] = nv;
				this.$router.replace({ query });
				await this.getList(query);
			},
			paging(offset) {
				this.changeImmediately(offset, 'offset');
			},
			init() {
				if (this.searchType !== 1) {
					this.$refs.filter.$refs.idBrand.init();
				}
				this.startFactorsInsertDate = '';
				this.endFactorsInsertDate = '';
				this.startModifiedFactorsDate = '';
				this.endModifiedFactorsDate = '';
				this.startDate = '';
				this.endDate = '';
				this.startModifiedDate = '';
				this.endModifiedDate = '';
				this.startReleaseDate = '';
				this.endReleaseDate = '';
				this.idProduct = '';
				this.productTitle = '';
				this.idBrandType = null;
				this.minPrice = '';
				this.maxPrice = '';
				this.productText = '';
				this.isDiscontinue = null;
				this.idBrand = null;
				this.keyword = '';
				this.colorType = '';
				this.firstCategory = null;
				this.secondCategory = null;
				this.thirdCategory = null;
				this.isDisplay = null;
				this.maxRatingAvg = '';
				this.minRatingAvg = '';
				this.minReviewCount = '';
				this.maxReviewCount = '';
				this.$refs.filter.init();
			},
		},
	};
</script>
